// src/store/useTypedSelector.ts

import { useSelector          ,
         useDispatch          ,
         TypedUseSelectorHook }  from 'react-redux';

import { RootState            }  from './generalReducer';

import { AppDispatch            }  from './store';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useTypedDispatch = () => useDispatch<AppDispatch>();
